export const forbiddenCharacters = ['#', '&'];

export const handlePasswordKeyDown = (e) => {
    if (forbiddenCharacters.includes(e.key)) {
        e.preventDefault();
    }
};  